import React from 'react';

class HomeIcon extends React.Component {

  render() {
    return (
      <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2.75" y="7" width="8" height="8" rx="1" fill="white" stroke="#244E81" strokeWidth="1.2"/>
        <rect x="12.5" y="5" width="1.2" height="10" fill="white"/>
        <rect y="5" width="1.2" height="10" fill="white"/>
        <rect x="0.019043" y="5" width="7" height="1.2" transform="rotate(-30 0.019043 5)" fill="white"/>
        <rect width="7" height="1.2" transform="matrix(-0.866025 -0.5 -0.5 0.866025 13.6812 5)" fill="white"/>
        <path d="M6.8501 3C7.67852 3 8.3501 2.32843 8.3501 1.5C8.3501 0.671573 7.67852 0 6.8501 0C6.02167 0 5.3501 0.671573 5.3501 1.5C5.3501 2.32843 6.02167 3 6.8501 3Z" fill="white"/>
      </svg>

    )
  }

}

export default HomeIcon;
